import React from "react";
import { Outlet } from "react-router-dom";
import ClientPortalSectionShell from "../components/clientPortal/ClientPortalSectionShell";
import { CLIENT_PORTAL_PRIMARY_NAV } from "../clientPortal/clientPortalPrimaryNav";

export default function ClientAccountLayout() {
  return (
    <ClientPortalSectionShell
      navLabel="Portal navigation"
      items={CLIENT_PORTAL_PRIMARY_NAV}
    >
      <Outlet />
    </ClientPortalSectionShell>
  );
}
